import AddPermissions from "../components/Permission/AddPermissions";
import ViewPermissions from "../components/Permission/AddPermissions";

const PermissionsPage: React.FC = () => {
  return <AddPermissions />;
};

export default PermissionsPage;
